import { fetchTranslationData } from "../../services/translation/translation";
import { config, ServiceTranslation } from "../../utils/constants";
import { useEffect, useState } from "react";
import { capitalizeWords, getLayoutDirection } from "../../utils/util";
import Warning from "../common/Warning";
import { Loader } from "../../common/Loader";
import axios from "axios";

const getEscortQRCodeDetail = (encodeValue) => {
    return axios.request({
        url: `${config.escortLeaveServices}qrcode?encode=${encodeValue}`
    });
};

const EscortQrVerification = () => {
    const [translationMap, setTranslationMap] = useState(null);
    const [qrData, setQrData] = useState(null);
    const [error, setError] = useState(null);

    const urlParams = window.location.search;
    const encode = urlParams.match(/encode=([^&]*)/)?.[1];

    useEffect(() => {
        fetchTranslationData(ServiceTranslation.EscortLeave).then(setTranslationMap);

        getEscortQRCodeDetail(encode)
        .then((result) => {
            if (result.status === 200) {
                setQrData(result.data.data);
            } else {
                setError("Invalid QR Code or data not found.");
            }
        })
        .catch((err) => {
            setError("Something went wrong while fetching data.");
            console.error(err);
        });
    }, [encode]);

    if (error) {
        return (
            <div className={`custombody_color ${getLayoutDirection()}`} id="sectionSickLeaveQr">
                <section className="w-100 clearfix SickLeaveConfirmationSection" id="CoverPlanActive">
                    <div className="barcode_header">
                        <div className="container customContainer">
                            <div className="inner_header_box">
                                <div className="img_box">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a>
                                        <img
                                            src={`${config.assestsBase}img/sickleave_barcode_img2.svg`}
                                            alt="Displaying dubaihealth logo"
                                            className="desktop_img" />
                                        <img
                                            src={`${config.assestsBase}img/sickleave_barcode_res_img2.svg`}
                                            alt="Displaying dubaihealth logo"
                                            className="responsive_img" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container customContainer">
                        <div className="Title_Inner_Box">
                            <h6 className="MainTitleOne">
                                {translationMap?.escort_application_verification}
                            </h6>
                        </div>

                        <Warning heading={translationMap?.invalidQRMessage} desc="" />
                    </div>
                </section>
            </div>);

    }

    if (!translationMap || !qrData) return <Loader />;

    const {
        name,
        emiratesId,
        dateOfIssue,
        returnToWork,
    } = qrData;

    return (
        <div className={`custombody_color ${getLayoutDirection()}`} id="sectionSickLeaveQr">
            <section className="w-100 clearfix SickLeaveConfirmationSection" id="CoverPlanActive">
                <div className="barcode_header">
                    <div className="container customContainer">
                        <div className="inner_header_box">
                            <div className="img_box">
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                <a>
                                    <img
                                        src={`${config.assestsBase}img/sickleave_barcode_img2.svg`}
                                        alt="Displaying dubaihealth logo"
                                        className="desktop_img" />
                                    <img
                                        src={`${config.assestsBase}img/sickleave_barcode_res_img2.svg`}
                                        alt="Displaying dubaihealth logo"
                                        className="responsive_img" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container customContainer">
                    <div className="Title_Inner_Box">
                        <h6 className="MainTitleOne">
                            {translationMap?.escort_application_verification}
                        </h6>
                    </div>

                    <div className="cover_inner_wrapper">
                        <div className="cover_main_box1">
                            <div className="AlertInnerBox GreenAlertInnerBox alert fade show">
                                <div className="Icon_box">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a><span className="material-symbols-outlined">check_circle</span></a>
                                </div>
                                <div className="alert_text">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <h6><a>{translationMap?.certificate_is_verified}</a></h6>
                                    <p className="number_txt">
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a>{translationMap?.dubai_health_info_correct}</a>
                                    </p>
                                </div>
                            </div>

                            <div className="Sick_Leave_Main_Wrapper">
                                <div className="status_main_box status_main_box2">
                                    <div className="content_box">
                                        <ul className="detail_box">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            <li><p><span>{translationMap?.name}</span><a>{capitalizeWords(name)}</a></p>
                                            </li>
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            <li><p><span>{translationMap?.emirates_id}</span><a>{emiratesId}</a></p>
                                            </li>
                                            <li>
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                <p><span>{translationMap?.valid_from}:</span><a>{dateOfIssue}</a></p>
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                <p><span>{translationMap?.to}:</span><a>{returnToWork}</a></p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cover_main_box2"></div>
                    </div>
                </div>
            </section>
        </div>);

};

export default EscortQrVerification;